import styled from 'styled-components';
import posed from 'react-pose';

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-bottom: 100px;
`;

export const Fields = styled.div`
  max-width: 770px;
`;

export const Footer = styled.div`
  display: flex;
  line-height: 18px;
`;

export const Steps = styled.div`
  margin-left: auto;
  overflow: hidden;
  font-size: 12px;
  line-height: 18px;
  min-width: 70px;
  color: #7f7f7f;
  text-transform: uppercase;
  text-align: right;

  @media (min-width: 1000px) {
    font-size: 16px;
  }
`;

export const Step = styled(
  posed.span({
    preEnter: {
      opacity: 0,
      y: 30,
      transition: { duration: 400 }
    },
    enter: {
      opacity: 1,
      y: 0,
      transition: { duration: 400 }
    },
    exit: {
      opacity: 0,
      y: -30,
      transition: { duration: 400 }
    }
  })
)`
  display: inline-block;
`;

export const Progress = styled.div`
  position: relative;
  margin-bottom: 16px;
  height: 4px;
  background-color: ${props => (props.isError ? '#d56262' : '#ffed00')};
  width: ${props => `${props.progress}%`};
  transition: width 0.4s ease-in-out, background-color 0.4s ease-in-out;
`;

export const Error = styled(
  posed.div({
    preEnter: {
      opacity: 0
    },
    enter: {
      opacity: 1,
      transition: { duration: 400 }
    },
    exit: {
      opacity: 0,
      transition: { duration: 400 }
    }
  })
)`
  line-height: 18px;
  font-size: 18px;
  color: #d56262;
`;
